module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 4.fcc55dd8.png";